import { PincodeData } from 'src';
import { leadAttributes, getPersonAttributes } from '.';

export const testPincodePersonLeadDataPermite = {
  status: {
    result: 'success',
    timestamp: '2021-05-05 18:07:02',
    code: 1,
    time: 0.5742380619049072,
  },
  params: {
    pincode: 'PINCODE-PERSON-LEAD-PERMITE',
    token: 'VW_DDB_FORM_NOCOMPRA',
  },
  content: [
    {
      attributes: [...getPersonAttributes(true)]
    },
    {
      attributes: [...leadAttributes]
    },
  ],
};

export const testPincodePersonLeadDataNoPermite = {
  status: {
    result: 'success',
    timestamp: '2021-05-05 18:07:02',
    code: 1,
    time: 0.5742380619049072,
  },
  params: {
    pincode: 'PINCODE-PERSON-LEAD-NO-PERMITE',
    token: 'VW_DDB_FORM_NOCOMPRA',
  },
  content: [
    {
      attributes: [...getPersonAttributes(false)]
    },
    {
      attributes: [...leadAttributes]
    },
  ],
};
